<template>
  <div class="app-layout-container">
    <app-header />
    <main class="app-layout">
      <app-menu />
      <app-main />
    </main>
  </div>
</template>

<script>
import { AppHeader, AppMenu, AppMain } from './components';

export default {
  name: 'Layout',
  components: {
    AppHeader,
    AppMenu,
    AppMain
  }
};
</script>

<style lang="scss" scoped>
.app-layout-container {
  padding: 15px;
  padding-top: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: url('~@/assets/app-bg.png') 0% 0% / 100% 100% no-repeat;
  background-size: cover;

  .app-layout {
    margin-top: 64px;
    gap: 10px;
    display: flex;
    height: calc(100% - 64px);
    overflow: hidden;
  }
}
</style>
